import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ReportService } from '@app/modules/report/services';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class CanViewReportGuard implements CanActivate {
  constructor(private readonly reportService: ReportService, private readonly router: Router,
    private readonly authService: AuthService
  ) { }
  canAccess = false;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.user.isAdmin) {
      return this.reportService.hasAdminAccess().pipe(
        map((response: any) => {
          if (response?.adminAccess?.canViewReports) {
            return true;
          } else {
            this.router.navigate(['/dashboard']);
          }
        }),
        catchError((error) => {
          console.log('error:', error);
          this.router.navigate(['/dashboard']);
          return of(false);
        })
      )
    } else {
      return of(true);
    }
  }

}
